module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_nightview@3x-86c94e3e79a27a6009bfc960bd84cc8a.webp";